import { useEffect, useState } from 'react';
import { featureFlagClient } from './feature-flag-client';

export const useFeatureFlag = <T = boolean>(
  flagName: string,
  defaultValue: T,
) => {
  // Get the initial value from LaunchDarkly (it may fall back to the defaultValue)
  // if the LaunchDarkly client isn't ready yet
  const initialValue = featureFlagClient.get(flagName, defaultValue);
  const [flag, setFlag] = useState(initialValue);

  // Subscribe to updates from LaunchDarkly, and update our flag state with the
  // new value
  useEffect(
    () => {
      const onFlagChanged = (newValue: T) => setFlag(newValue);
      featureFlagClient.on(flagName, onFlagChanged);

      // Ensure the subscription is cleaned up when the component is unmounted, or
      // the flagName changes for some reason
      return () => featureFlagClient.off(flagName, onFlagChanged);
    },
    [flagName],
  );

  return flag;
};
